import { IMAGES_BASE_PATH } from "../config/constants";

export const getImage = (imageObject: any) => {
  if (imageObject && typeof imageObject === 'object' && 'key' in imageObject) {
    return IMAGES_BASE_PATH + imageObject.key;
  } else if (typeof imageObject === 'string') {
    return IMAGES_BASE_PATH + imageObject;
  } else {
    return IMAGES_BASE_PATH + 'default_user/user_profile_image.jpg';
  }
};



export const getVideo = (videoObject: { key?: string } | string | null | undefined): string => {
    if (videoObject && typeof videoObject === 'object' && 'key' in videoObject) {
        return IMAGES_BASE_PATH + videoObject.key;
    } else if (videoObject) {
        return IMAGES_BASE_PATH + videoObject;
    } else {
        return IMAGES_BASE_PATH + 'default_video/default_video.mp4'; // Default video path
    }
};

export const getImageSpeaker = (imageObject: any, gender?: string) => {
  console.log("Image Object in getImageSpeaker:", gender);
  if (imageObject && typeof imageObject === "object" && "key" in imageObject) {
    return IMAGES_BASE_PATH + imageObject.key;
  }

  if (typeof imageObject === "string") {
    return IMAGES_BASE_PATH + imageObject;
  }

  // Fallback to gender-based dummy images from public/assets
  if (gender?.toLowerCase() === "mr") {
    return "/images/dummy_man.jpeg"; 
   
  }
   return "/images/dummy_female.png";

  
};



